import React from 'react'
import PropTypes from 'prop-types'
import './index.css'

const FormSetPersistence = ({onYes, onNo, onCancel}) => {
  return (
    <div className='mofo'>
      <div className='mofo-con'>
        <div className='lf'>
          <p>Odhlásit při zavření okna prohlížeče</p>
          <div>
            <button className='lf-b lf-b-w2' onClick={onYes}>Ano</button>
            <button className='lf-b lf-b-w2' onClick={onNo}>Ne</button>
            <button className='lf-b lf-b-w2' onClick={onCancel}>Zrušit</button>
          </div>
        </div>
      </div>
    </div>
  )
}

FormSetPersistence.propTypes = {
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default FormSetPersistence



// WEBPACK FOOTER //
// ./src/components/UserForms/FormSetPersistence.js